module.exports = __webpack_public_path__ + "static/media/share.f88eae18.svg";